
import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-20 bg-[#F97316]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/7cf291ba22b5b11e9a99d9275e3e31d1.jpg"
                alt="Sobre Nosotros"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="text-white">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              {t('about.title')}
            </h2>
            <p className="text-lg text-white/90 mb-6 leading-relaxed">
              {t('about.p1')}
            </p>
            <p className="text-lg text-white/90 mb-6 leading-relaxed">
              {t('about.p2')}
            </p>
            <p className="text-lg text-white/90 leading-relaxed">
              {t('about.p3')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
